<template lang="pug">
  .wrapper
    section.content.p-4
      // シナリオポップアップ毎にループ
      div(v-for="(scenario, sIndex) in scenarioPopups" :key="scenario.name")
        // 各クリエイティブをループ
        div(v-for="(creative, cIndex) in scenario.creatives" :key="'creative-'+sIndex+'-'+cIndex")
          .table-responsive
            table.table.table-bordered
              thead
                tr
                  th(:colspan="4 + display_col_names.length + answerCount(creative.datas)")
                    span クリエイティブID: {{ creative.id }}
                    toggle-button.ml-2.mb-0(
                      :value="!creative.hide_flag",
                      :labels="true",
                      @change="switchCreative($event, creative.url_token)",
                      :sync="false"
                    )
                tr
                  th シナリオ
                  th 表示回数
                  th クリック数
                  th クリック率
                  th(v-for="name in display_col_names" :key="'cv-'+name") {{ translateName(name) }}
                  th(v-for="n in answerCount(creative.datas)" :key="'ans-header-'+n") ボタン{{ n }}
              tbody
                // シナリオステップのデータ
                tr(v-for="(record, i) in creative.datas" :key="'creative-'+sIndex+'-'+cIndex+'-'+i")
                  td
                    | {{ i + 1 }}
                    br/
                    img(:src="record.image_url" style="max-width: 100px; max-height: 100px;")
                  td
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else) {{ record.imp }}
                  td
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else) {{ record.clicks }}
                  td
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else) {{ calculateCTR(record.clicks, record.imp) }}
                  td(v-for="name in display_col_names" :key="'cv-'+name")
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else) --
                  td(v-for="n in answerCount(creative.datas)" :key="'ans-'+i+'-'+n")
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else)
                      div {{ record['answer' + n] || '0' }}
                      div.text-muted.small {{ calculateButtonPercentage(record['answer' + n], record.clicks) }}

                // 結果画像のデータ
                tr(v-for="(image, imgIndex) in creative.result_images" :key="'result-image-'+sIndex+'-'+cIndex+'-'+imgIndex")
                  td
                    | 結果 {{imgIndex+1}}
                    br/
                    template(v-if="image.is_chained")
                      img(v-if="image.next_scenario_popup_thumbnail_url" :src="image.next_scenario_popup_thumbnail_url" style="max-width: 100px; max-height: 100px;")
                      div(v-if="image.next_scenario_popup_name") 接続先: {{ image.next_scenario_popup_name }}
                      span.badge.badge-danger(v-if="image.next_scenario_popup_status === 'deleted'") 削除済み
                      span.badge.badge-warning(v-else-if="image.next_scenario_popup_status === 'hidden'") 非表示中
                    template(v-else-if="image.image_url")
                      img(:src="image.image_url" style="max-width: 100px; max-height: 100px;")
                    template(v-else-if="image.iframe_embed_url")
                      .small.text-muted iframe
                      .small.text-truncate.text-muted(style="max-width: 150px;", :title="image.iframe_embed_url")
                        | {{ image.iframe_embed_url }}
                    template(v-else)
                      .small.text-muted 結果画像無し
                      template(v-if="image.no_link")
                        .small.text-muted リンクなし
                      template(v-else-if="image.link")
                        .small リンクあり{{ linkTabLabel(image) }}
                        .small.text-truncate.text-muted(style="max-width: 150px;", :title="image.link")
                          | {{ image.link }}
                  td
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else) {{ image.imp }}
                  td
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else-if="image.is_chained") --
                    template(v-else-if="image.iframe_embed_url") --
                    template(v-else) {{ image.click }}
                  td
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else-if="image.is_chained") --
                    template(v-else-if="image.iframe_embed_url") --
                    template(v-else) {{ calculateCTR(image.click, image.imp) }}
                  td(v-for="name in display_col_names" :key="'cv-'+name")
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else-if="image.is_chained") --
                    template(v-else-if="image.iframe_embed_url") --
                    template(v-else) {{ image[name] || '0' }}
                  td(v-for="n in answerCount(creative.datas)" :key="'result-ans-'+imgIndex+'-'+n")
                    template(v-if="isLoading")
                      div.la-ball-pulse.la-sm
                        div
                        div
                        div
                    template(v-else) --

      div(v-if="scenarioPopups.length === 0 && fetched")
        .alert.alert-info(role="alert") データが存在しませんでした
  </template>

  <script>
  import reportApi from '../apis/report'
  import { linkTabLabel } from '../utils/linkTabLabel'
  export default {
    name: 'ScenarioPopupReport',
    data() {
      return {
        scenarioPopups: [],
        fetched: false,
        isLoading: false,
      }
    },
    computed: {
      display_col_names() {
        return this.$store.getters['report/display_col_names'] || []
      }
    },
    methods: {
      translateName(name) {
        return this.$store.state.report.locales[name] || name
      },
      linkTabLabel,
      fetchScenarioPopups() {
        this.isLoading = true;
        reportApi.scenario_creative({
          date_from: this.$store.state.report.date_from,
          date_to: this.$store.state.report.date_to,
          creative_id: this.$store.state.report.selected_creative_id,
        })
        .then(response => {
          this.scenarioPopups = response.data.scenarioPopups;
          this.fetched = true;
          this.isLoading = false;
        })
        .catch(error => {
          console.error("Error fetching scenario popups:", error);
          this.isLoading = false;
        });
      },
      answerCount(creativeData) {
        let maxCount = 0;
        creativeData.forEach(record => {
          Object.keys(record).forEach(key => {
            if (key.startsWith("answer")) {
              const num = parseInt(key.replace("answer", ""), 10);
              if (num > maxCount) { maxCount = num; }
            }
          });
        });
        return maxCount;
      },
      switchCreative(e, url_token) {
        this.$store.dispatch("report/toggleCreativeDisplay", { url_token });
      },
      calculateCTR(clicks, impressions) {
        if (!impressions || impressions === 0) return '0.00%';
        const ctr = (clicks / impressions) * 100;
        return ctr.toFixed(2) + '%';
      },
      calculateButtonPercentage(buttonClicks, totalClicks) {
        if (!totalClicks || totalClicks === 0) return '0.00%';
        const buttonClicks_num = parseInt(buttonClicks || 0);
        const percentage = (buttonClicks_num / totalClicks) * 100;
        return percentage.toFixed(2) + '%';
      }
    },
    mounted() {
      this.fetchScenarioPopups();
    },
    watch: {
      '$store.state.report.date_from': function() {
        this.fetchScenarioPopups();
      },
      '$store.state.report.date_to': function() {
        this.fetchScenarioPopups();
      },
      '$store.state.report.selected_creative_id': function() {
        this.fetchScenarioPopups();
      }
    }
  }
  </script>

  <style scoped>
  /* 必要に応じてスタイルを追加 */
  </style>
